import React, { createContext, useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

// Create a context for the auth state
const AuthContext = createContext(null);

export function useAuth() {
    return useContext(AuthContext);
}

export function AuthProvider({ children }) {
    const [user, setUser] = useState(null);
    const navigate = useNavigate();

    const login = (token) => {
        localStorage.setItem('token', token);
        
        setUser({ token});
    };

    const logout = () => {
        localStorage.removeItem('token');
        localStorage.clear();
        setUser(null);
        navigate('/Login');
    };

    return (
        <AuthContext.Provider value={{ user, login, logout }}>
            {children}
        </AuthContext.Provider>
    );
}

// Then wrap your application in the AuthProvider component
